import { Link } from "react-router-dom";
import { notFound, identity } from "@/config";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="flex min-h-svh flex-col items-center justify-center bg-noir px-6 text-center">
      <span className="grid h-14 w-14 place-items-center rounded-full border border-gold/60 font-serif text-lg text-gold">{identity.monogram}</span>
      <p className="label mt-10 text-gold">404</p>
      <h1 className="mt-4 font-serif text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl">{notFound.headline}</h1>
      <Link to="/" data-testid="not-found-home" className="btn btn-outline mt-10">{notFound.cta}</Link>
    </main>
  );
}
